import api, { unwrap } from './client';
import { partage } from './partage';

// opts.version → lit une version FIGÉE (budget) au lieu du prévisionnel vivant.
// opts.through → arrêté d'affichage : la vue se borne à ce mois (≤ clôture).
export const getPlView      = (tenantId, year, opts = {}) => partage(
  `pl:${tenantId}:${year}:${JSON.stringify(opts)}`,
  () => unwrap(api.get(`/financials/pl/${tenantId}`,
    { params: { year, ...(opts.version ? { version: opts.version } : {}),
      ...(opts.through ? { through: opts.through } : {}),
      ...(opts.loaded ? { loaded: true } : {}) } })));

/* Atterrissage de l'exercice (Synthèse du Résultat prévisionnel, 2026-09-27) :
   réalisé, à venir, atterrissage, N-1, ratios et productivité. */
export const getPlLanding = (tenantId, year) =>
  unwrap(api.get(`/financials/pl/${tenantId}/landing`, { params: { year } }));

/* Saisies de la Synthèse (2026-09-28) : le réalisé cumulé d'une ligne quand
   aucune comptabilité n'est importée, et l'à venir tapé en un total. Montants
   tels qu'on les lit, une charge en positif. */
export const patchRealizedCumul = (tenantId, payload) =>
  unwrap(api.patch(`/financials/pl/${tenantId}/realized-cumul`, payload));
export const patchRemainingTotal = (tenantId, payload) =>
  unwrap(api.patch(`/financials/pl/${tenantId}/remaining-total`, payload));

/* Section revenus seule — accessible au module Ventes (périmètre `sales`) pour
   aligner le plan sur la comptabilité, sans exposer charges ni marges. */
export const getPlRevenueView = (tenantId, year) =>
  unwrap(api.get(`/financials/pl/revenue/${tenantId}`, { params: year ? { year } : {} }));
export const listPlAccounts   = (tenantId)       => unwrap(api.get(`/financials/pl/${tenantId}/accounts`));
export const createPlAccount  = (tenantId, account_number, account_desc) =>
  unwrap(api.post(`/financials/pl/${tenantId}/accounts`, { account_number, account_desc }));
export const deletePlAccounts = (tenantId, account_numbers) =>
  unwrap(api.post(`/financials/pl/${tenantId}/accounts/delete`, { account_numbers }));
export const renameSection  = (tenantId, code, label) => unwrap(api.patch(`/financials/pl/${tenantId}/sections/${code}`, { label }));
export const resetPlSection = (tenantId, section) => unwrap(api.post(`/financials/pl/${tenantId}/reset-section`, { section }));

export const patchPlAccountLine = (tenantId, account, reporting_line) =>
  unwrap(api.patch(`/financials/pl/${tenantId}/accounts/${encodeURIComponent(account)}`, { reporting_line }));

export const setMonthly = (tenantId, payload) =>
  unwrap(api.patch(`/financials/pl/${tenantId}/monthly`, payload));

// Forecast (prévisionnel) par reporting line / mois : { year, reporting_line_id, month, amount }
export const setLineForecast = (tenantId, payload) =>
  unwrap(api.patch(`/financials/pl/${tenantId}/forecast`, payload));

// Génération du forecast : remplit les mois ouverts de toutes les lignes
// dont forecast_method est défini. { year }
export const generateForecast = (tenantId, payload) =>
  unwrap(api.post(`/financials/pl/${tenantId}/forecast/generate`, payload));

// Forecast automatique charges sociales : { year, taux } (taux décimal 0..1)
export const fillCsForecast = (tenantId, payload) =>
  unwrap(api.post(`/financials/pl/${tenantId}/forecast/fill-cs`, payload));

// Forecast automatique impôts : { year, taux } (taux décimal 0..1)
export const fillTaxForecast = (tenantId, payload) =>
  unwrap(api.post(`/financials/pl/${tenantId}/forecast/fill-tax`, payload));

// Structure éditable (reporting lines)
export const listLines   = (tenantId)                 => unwrap(api.get(`/financials/pl/${tenantId}/lines`));
export const createLine  = (tenantId, section, label) => unwrap(api.post(`/financials/pl/${tenantId}/lines`, { section, label }));
export const updateLine  = (tenantId, lineId, patch)  => unwrap(api.patch(`/financials/pl/${tenantId}/lines/${lineId}`, patch));
export const deleteLine  = (tenantId, lineId)         => unwrap(api.delete(`/financials/pl/${tenantId}/lines/${lineId}`));
// Coûts des produits vendus alignés, ou non, sur le coût des ventes calculé (2026-09-29).
export const setCogsAlign = (tenantId, year, aligned) => unwrap(api.put(`/financials/pl/${tenantId}/cogs-align`, { year, aligned }));
export const reorderLines = (tenantId, ids)           => unwrap(api.post(`/financials/pl/${tenantId}/lines/reorder`, { ids }));

// Ajustements manuels (corrections / reclassements)
export const listAdjustments      = (tenantId, year) => unwrap(api.get(`/financials/pl/${tenantId}/adjustments`, { params: { year } }));
export const createAdjustment     = (tenantId, payload) => unwrap(api.post(`/financials/pl/${tenantId}/adjustments`, payload));
export const updateAdjustment     = (tenantId, adjId, payload) => unwrap(api.patch(`/financials/pl/${tenantId}/adjustments/${adjId}`, payload));
export const deleteAdjustment     = (tenantId, adjId) => unwrap(api.delete(`/financials/pl/${tenantId}/adjustments/${adjId}`));
export const createAdjustmentLine = (tenantId, adjId, payload) => unwrap(api.post(`/financials/pl/${tenantId}/adjustments/${adjId}/lines`, payload));
export const updateAdjustmentLine = (tenantId, adjId, lineId, payload) => unwrap(api.patch(`/financials/pl/${tenantId}/adjustments/${adjId}/lines/${lineId}`, payload));
export const deleteAdjustmentLine = (tenantId, adjId, lineId) => unwrap(api.delete(`/financials/pl/${tenantId}/adjustments/${adjId}/lines/${lineId}`));

export const importPlExcel = (tenantId, file, year) => {
  const fd = new FormData();
  fd.append('file', file);
  return unwrap(api.post(`/financials/pl/${tenantId}/import`, fd, {
    params: { year },
    headers: { 'Content-Type': 'multipart/form-data' },
  }));
};
